import { CreateEditSellForm } from '@/components/Pages/Sells/Create/CreateEditSellForm';
import { createFileRoute } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import { Stack, Breadcrumbs } from '@mui/joy';
import { SellEditProvider } from '@/contexts/SellEditContext';

export const Route = createFileRoute('/_protected/sells/create')({
  component: CreateSell,
});

function CreateSell() {
  return (
    <>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/sells'>Ventas</Link>
        </Breadcrumbs>
      </Stack>

      <SellEditProvider>
        <CreateEditSellForm isCreate />
      </SellEditProvider>
    </>
  );
}
